module.exports = __webpack_public_path__ + "img/image03_sp.14d3e81e.jpg";